import { planningAPI } from "../../axios";

export const actions = {
    // Api Section
    GetApiSections(context, data){
        return planningAPI.get(`ApiSection/All`);
    },
    GetSingleApiSection(context, data){
        return planningAPI.get(`ApiSection/${data}`);
    },
    CreateApiSection(context, data){
        return planningAPI.post(`ApiSection/Add`, data);
    },
    UpdateApiSection(context, data){
        return planningAPI.put(`ApiSection/Update/${data.id}`, data);
    },
    RemoveApiSection(context, data){
        return planningAPI.delete(`ApiSection/Remove/${data}`);
    },

    // Section Group
    GetSectionGroups(context, data){
        return planningAPI.get(`ApiSectionGroup/All`);
    },
    GetGroupBySection(context, data){
        return planningAPI.get(`ApiSectionGroup/ApiSection/${data}`);
    },
    CreateSectionGroup(context, data){
        return planningAPI.post(`ApiSectionGroup/Add`, data);
    },
    UpdateSectionGroup(context, data){
        return planningAPI.put(`ApiSectionGroup/Update/${data.id}`, data);
    },
    RemoveSectionGroup(context, data){
        return planningAPI.delete(`ApiSectionGroup/Remove/${data}`);
    },

    // Group Item
    GetGroupItems(context, data){
        return planningAPI.get(`ApiSectionGroupItem/All`);
    },
    GetItemByGroup(context, data){
        return planningAPI.get(`ApiSectionGroupItem/ApiSectionGroup/${data}`);
    },
    CreateGroupItem(context, data){
        return planningAPI.post(`ApiSectionGroupItem/Add`, data);
    },
    UpdateGroupItem(context, data){
        return planningAPI.put(`ApiSectionGroupItem/Update/${data.id}`, data);
    },
    RemoveGroupItem(context, data){
        return planningAPI.delete(`ApiSectionGroupItem/Remove/${data}`);
    }
}